// extracted by mini-css-extract-plugin
module.exports = {"word":"_760c29fef449a5b99f0a18925a70e69f"};